/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

"use client";

import { Faq, NamespaceKeyHavingFaqs } from "@/types/messages-keys/keys";
import { AccordionHeader, AccordionTrigger } from "@radix-ui/react-accordion";
import { Plus, X } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem } from "../../ui/accordion";
import FooterLink from "../links/FooterLink";
import { linkifyNode } from "@/lib/linkify";

type PropsType = {
  countryName?: string;
  faqs: Faq[];
  namespaceKey: NamespaceKeyHavingFaqs;
};

function Accordions({ namespaceKey, faqs, countryName }: PropsType) {
  const [isMount, setIsMount] = useState<true | undefined>(true);
  const t = useTranslations(`${namespaceKey}`);

  useEffect(function () {
    setIsMount(undefined);
  }, []);
  return (
    <div className="mt-12">
      <Accordion
        type="multiple"
        className="grid gap-x-10 gap-y-6 lg:grid-cols-2"
      >
        {faqs.map((item, index) => (
          <div key={index}>
            <AccordionItem
              value={`${index}`}
              key={index}
              className="group h-full w-full rounded-lg border-2 border-transparent transition-all data-[state=open]:border-primary data-[state=open]:bg-muted dark:data-[state=open]:bg-card"
            >
              <AccordionHeader asChild>
                <h3 className="w-full">
                  <AccordionTrigger className="group flex w-full flex-1 items-start justify-between gap-2 rounded-b-lg rounded-t-lg bg-muted px-6 py-5 text-left text-body-md font-500 transition-all group-hover:text-primary data-[state=open]:rounded-b-none data-[state=open]:text-primary dark:bg-card xl:text-body-lg [&[data-state=open]>svg]:rotate-180">
                    {countryName
                      ? t(`faqData.faqs.${item.key}.title`, { countryName })
                      : t(`faqData.faqs.${item.key}.title`)}
                    <Plus className="h-6 w-6 shrink-0 text-foreground transition-transform duration-200 group-hover:text-primary group-data-[state=open]:hidden group-data-[state=open]:text-primary" />
                    <X className="hidden h-6 w-6 shrink-0 text-foreground transition-transform duration-200 group-hover:text-primary group-data-[state=open]:flex group-data-[state=open]:text-primary" />
                  </AccordionTrigger>
                </h3>
              </AccordionHeader>
              <AccordionContent
                className="text-body-sm text-muted-foreground dark:bg-card dark:text-primary-foreground dark:opacity-80 xl:text-body-md"
                forceMount={isMount}
              >
                {item.isFaqHaveLink &&
                  item.href &&
                  linkifyNode(
                    t.rich(`faqData.faqs.${item.key}.body`, {
                      FooterLink: (text) => (
                        <FooterLink
                          href={item.href as string}
                          className="inline text-primary underline underline-offset-2"
                        >
                          {text}
                        </FooterLink>
                      ),
                      br: () => <br />,
                    }),
                  )}

                {item.isFaqHaveListItems &&
                  linkifyNode(
                    t.rich(`faqData.faqs.${item.key}.body`, {
                      ul: (text) => <ul className="mx-9 list-disc">{text}</ul>,

                      li: (text) => <li>{linkifyNode(text)}</li>,
                      br: () => <br />,
                    }),
                  )}

                {!item.isFaqHaveLink &&
                  !item.isFaqHaveListItems &&
                  linkifyNode(
                    t.rich(`faqData.faqs.${item.key}.body`, {
                      br: () => <br />,
                    }),
                  )}
              </AccordionContent>
            </AccordionItem>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default Accordions;
